<div class="sidebar-inner" [ngClass]="{open: navService.sidebarState.sidenavOpen}">
  <div class="sidebar-header">
    <img src="./assets/images/logos/logo.svg" alt="" class="logo-lg">
    <img src="./assets/images/logos/logo-sm.svg" alt="" class="logo-sm">
  </div>
  <div class="expiration text-center" *ngIf="licenseExpiration">
    <p class="orange-color font-15 fontMedium" *ngIf="licenseExpiration > 0">{{'profile.expiring soon' | translate}}
    </p>
    <p class="red-color font-15 fontMedium" *ngIf="licenseExpiration <= 0">{{'profile.already expired' | translate}}
      <br>
      <span class="text-color font-14 fontMedium">{{'profile.contact with' | translate}}</span>
    </p>
    <p class="text-color font-14 fontMedium mt-2" *ngIf="licenseExpiration >= 1">{{licenseExpiration}} {{'promotion.Days' | translate}}</p>
  </div>

  <div class="search-container mt-2" *ngIf="nav.length > 5">
    <div class="input-group search-control">
      <div class="input-group-prepend">
        <button class="input-group-text" type="button">
          <img src="./assets/images/icons/search.svg" alt="">
        </button>
      </div>
      <input type="text" class="form-control" [(ngModel)]="searchText" [placeholder]="'forms.Search' | translate">
      <div class="input-group-prepend" *ngIf="searchText">
        <button class="input-group-text" type="button" (click)="searchText = ''">
          <mat-icon class="h-auto font-30">close</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="sidebar-list-menu">
    <ul *ngIf="loading">
      <li *ngFor="let item of counter(15)" class="load"><a></a></li>
    </ul>
    <ul *ngIf="!loading">
      <ng-container *ngFor="let item of nav">
        <li [hidden]="hideOption(item)"
          [class.selected]="item.selected"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: false }">

          <ng-template #itemMenuContent let-item="item">
            <div class="item-inner">
              <div [innerHTML]="item.icon | sanitizeHtml"></div>
              <div class="item-content">
                <span>{{item.title}}</span>
                <span class="desc">{{item.description}}</span>
              </div>
            </div>
          </ng-template>

          <ng-container *ngIf="item.type === 'link'">
            <a routerLink="{{item.state}}" routerLinkActive="active">
              <ng-container [ngTemplateOutlet]="itemMenuContent" [ngTemplateOutletContext]='{item}'></ng-container>
            </a>
          </ng-container>

          <ng-container *ngIf="item.type === 'dropDown'">
            <a (click)="selectItem(item)">
              <ng-container [ngTemplateOutlet]="itemMenuContent" [ngTemplateOutletContext]='{item}'></ng-container>

              <i class="material-icons" *ngIf="!item.selected">expand_more</i>
              <i class="material-icons" *ngIf="item.selected">expand_less</i>
            </a>

            <ul class="childNav">
              <ng-container *ngFor="let sub of item?.sub">
                <li class="nav-item" [hidden]="sub.hide">
                  <a routerLink="{{sub.state}}" routerLinkActive="active">
                    <span class="item-name">{{sub.title}}</span>
                  </a>
                </li>
              </ng-container>
            </ul>
          </ng-container>

        </li>
      </ng-container>
    </ul>
    <ul *ngIf="outSideLinks.length">
      <li *ngFor="let item of outSideLinks">
        <a [href]="item.url" target="_blank">
          <div class="item-inner">
            <img [src]="item.icon">
            <div class="item-content">
              <span>{{item.name}}</span>
            </div>
          </div>
        </a>
      </li>
    </ul>
  </div>
  <div class="sidebar-footer">
    <p>
      <b>© 2024 inndeve,</b>
      {{'general.All Rights Reserved' | translate}}
    </p>
  </div>
</div>
<div [ngClass]="{open: navService.sidebarState.sidenavOpen}" class="sidebar-overlay" (click)="toggelSidebar()"></div>
